import { Link } from "react-router-dom";
import LandingHeroModelCard from "./LandingHeroModelCard";
import {
  ACTION_SEE_PLANS,
  ACTION_TRY_QUESTION,
  HEADLINE_ACCENT,
  HEADLINE_LINES,
  HERO_LABEL,
  HREF_AMOSTRA,
  HREF_PLANOS,
  SLIDE_1_KICKER,
  SLIDE_1_SUBTITLE,
  activateSampleEntry,
} from "./landingHeroCopy";
import { LANDING_PLAN_CLICK_ALL, track } from "./landingTrack";
import "./LandingHero.css";

export default function LandingHero() {
  return (
    <section className="lh" aria-label={HERO_LABEL}>
      <div className="lh-slide">
        <div className="lh-copy">
          <div className="lh-lead">
            <p className="lh-kicker">{SLIDE_1_KICKER}</p>
            <h1 className="lh-title"><span className="lh-title-line">{HEADLINE_LINES[0]} </span><span className="lh-title-line">{HEADLINE_LINES[1]} </span><span className="lh-title-line lh-title-accent">{HEADLINE_ACCENT}</span></h1>
          </div>
          <p className="lh-subtitle">{SLIDE_1_SUBTITLE}</p>
          <div className="lh-actions">
            <a className="lh-primary" href={HREF_AMOSTRA} onClick={activateSampleEntry}>
              {ACTION_TRY_QUESTION}
            </a>
            <Link
              className="lh-secondary"
              to={HREF_PLANOS}
              onClick={() =>
                track("landing_plan_clicked", { product_id: LANDING_PLAN_CLICK_ALL })
              }
            >
              {ACTION_SEE_PLANS}
            </Link>
          </div>
        </div>
        <div className="lh-stage">
          <div className="lh-shapes" aria-hidden="true">
            <div className="lh-shape lh-shape-teal" />
            <div className="lh-shape lh-shape-bar" />
            <div className="lh-shape lh-shape-emerald" />
            <div className="lh-shape lh-shape-navy" />
            <div className="lh-shape lh-shape-amber" />
          </div>
          <div className="lh-stage-card">
            <LandingHeroModelCard />
          </div>
        </div>
      </div>
    </section>
  );
}
